import { firestoreConsoleDocUrl } from "src/utils/firestoreConsoleUrl";

export function slackBlockquote(text: string | null | undefined) {
  if (!text?.trim()) return null;

  return text
    .trim()
    .split("\n")
    .map((line) => `> ${line}`)
    .join("\n");
}

export function slackMarkdownLink(label: string, url: string | null) {
  if (!url) return label;
  return `<${url}|${label}>`;
}

export function formatErrorAlertSlackMessage({
  alert,
  userEmail,
  note,
  supportPageUrl,
}: {
  alert: {
    id: string;
    user: string;
    platform: string;
    message: string;
    errorMessage: string;
    stack: string;
    integrationId: string | null;
    createdAt: string | null;
  };
  userEmail: string;
  note?: string;
  supportPageUrl: string;
}) {
  const alertUrl = firestoreConsoleDocUrl("Error_Alerts", alert.id);
  const userUrl = firestoreConsoleDocUrl("Users", alert.user);
  const integrationUrl = alert.integrationId
    ? firestoreConsoleDocUrl("Plaid_Integrations", alert.integrationId)
    : null;

  const lines = [
    slackMarkdownLink("❗ *Reported Error alert*", supportPageUrl),
  ];

  const userQuote = slackBlockquote(alert.message);
  if (userQuote) {
    lines.push("", userQuote);
  }

  lines.push(
    "",
    `• *Platform:* ${alert.platform || "Unknown"}`,
    `• *User:* ${slackMarkdownLink(userEmail || alert.user, userUrl)}`,
    `• *Alert:* ${slackMarkdownLink(alert.id, alertUrl)}`,
    `• *Integration:* ${
      alert.integrationId
        ? slackMarkdownLink(alert.integrationId, integrationUrl)
        : "n/a"
    }`,
    `• *Received:* ${alert.createdAt || "n/a"}`
  );

  if (note?.trim()) {
    const supportNoteQuote = slackBlockquote(note);
    if (supportNoteQuote) {
      lines.push("", "*Support note:*", supportNoteQuote);
    }
  }

  lines.push(
    "",
    "*Technical error:*",
    "```",
    alert.errorMessage || "No technical error message captured.",
    "```"
  );

  if (alert.stack) {
    lines.push("", "*Stack trace:*", "```", alert.stack, "```");
  }

  return lines.join("\n");
}
